import { appVersion } from 'consts/app';
import { FormattedMessage } from 'utils/intl';

import messages from './Version.messages';
import classes from './Version.module.scss';

type Props = {
  apiVersion: string;
};

const Version = ({ apiVersion }: Props): JSX.Element => (
  <p className={classes.wrapper}>
    <FormattedMessage {...messages.version} values={{ apiVersion, clientVersion: appVersion }} />
  </p>
);

export default Version;
